import React from "react";
import { object, array, number, string } from "prop-types";
import { Link } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import "./story-card6.m.css";
import StoryDate from "../../atoms/story-date";

const StoryCard6 = ({ story, aspectRatio, imageType, headerType, headerLevel }) => {
  return (
    <div className="story-card story-card-6" styleName="story-card-6" id="story-card-6">
      <Link href={`/${story.slug}`}>
        {story["story-template"] === "sponsored" ? <div styleName="title">Featured Content</div> : null}
        <div styleName="card-wrapper">
          <div styleName="text-wrapper">
            <Headline text={story.headline} headerType={headerType} headerLevel={headerLevel} story={story} />
          </div>
          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            renderedWidth={720}
            widths={[720]}
            showVideoIcon
          />
        </div>
      </Link>
      <StoryDate story={story} />
    </div>
  );
};

StoryCard6.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 2,
  headerLevel: 2
};

StoryCard6.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number
};

export default StoryCard6;
